import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { useState, useEffect } from 'react';
import Button from './Button';
import Icon from './Icon';

type FiltersProps = {
  title: string;
  staticButtons?: string[];
  keys?: string[];
  onFilterChange?: (filters: string[]) => void;
  labelExtractor?: (segment: string) => string;
  rightSide?: React.ReactNode;
  icon?: IconProp;
};

function Filters(props: FiltersProps) {
  const { title, staticButtons, keys, onFilterChange, labelExtractor, rightSide, icon } = props;

  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  function handleButtonClick(label: string) {
    setActiveFilters(prev =>
      prev.includes(label) ? prev.filter(item => item !== label) : [...prev, label]
    );
  }

  function clearFilters() {
    setActiveFilters([]);
  }

  if (onFilterChange) {
    useEffect(() => {
      onFilterChange(activeFilters);
    }, [activeFilters, onFilterChange]);
  }

  return (
    <div className="py-4 filters-block">
      <div className="px-4 flex justify-between items-center">
        <div className="text-lg font-semibold flex items-center filter-title">
          {icon && <Icon icon={icon} className="mr-2" />}
          <span>{title}</span>
        </div>
        {rightSide}
      </div>
      {keys && keys.length > 0 && (
        <div
          className={`text-sm hide-scrollbar flex flex-row space-x-2 mt-3 overflow-x-auto px-4${
            activeFilters.length < 1 ? ' -ml-2' : ''
          }`}
        >
          <Button
            outline="border-blue-500"
            shape="oval"
            icon={['far', 'xmark']}
            iconPosition="left"
            className={`bg-blue-500 text-white flex-shrink-0${
              activeFilters.length > 0
                ? ' opacity-100 filter-on-active'
                : ' opacity-0 -mt-97 filter-on'
            }`}
            style={{ width: '100px', transition: 'all 0.5 ease' }}
            onClick={clearFilters}
          >
            Filters: {activeFilters.length}
          </Button>
          {staticButtons?.map(label => (
            <Button
              key={label}
              outline="border-black"
              shape="oval"
              className={`${
                activeFilters.includes(label)
                  ? 'bg-black text-white filter-tags-active'
                  : 'text-black filter-tags'
              }`}
              onClick={() => handleButtonClick(label)}
            >
              {label}
            </Button>
          ))}

          {keys?.map(keys => (
            <Button
              key={keys}
              outline="border-black"
              shape="oval"
              className={
                activeFilters.includes(keys)
                  ? 'bg-black text-white filter-tags-active'
                  : 'text-black filter-tags'
              }
              onClick={() => handleButtonClick(keys)}
            >
              {labelExtractor ? labelExtractor(keys) : ''}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}

export default Filters;
